"use client";

import { FC, ComponentProps } from "react";
import { Text } from "@/components/atoms/Text";
import * as ToastPrimitives from "@radix-ui/react-toast";

import { useToast } from "./use-toast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./Toast";

type ToasterProps = {
  viewportProps: ComponentProps<typeof ToastPrimitives.ToastViewport>;
  providerProps: ComponentProps<typeof ToastPrimitives.ToastProvider>;
  titleProps: ComponentProps<typeof ToastPrimitives.ToastTitle>;
  descriptionProps: ComponentProps<typeof ToastPrimitives.ToastDescription>;
};

export const Toaster: FC<ToasterProps> = ({
  viewportProps = {},
  providerProps = {},
  titleProps = {},
  descriptionProps = {},
}) => {
  const { toasts, dismiss } = useToast();

  return (
    <ToastProvider {...providerProps}>
      {toasts.map(function ({
        id,
        title,
        description,
        action,
        duration = 3000,
        variant,
        ...props
      }) {
        return (
          <Toast key={id} variant={variant} duration={duration} {...props}>
            <div className="tw-grid tw-gap-1">
              {title && (
                <ToastTitle {...titleProps}>
                  <Text typeface="headline-2-m">{title}</Text>
                </ToastTitle>
              )}
              {description && (
                <ToastDescription {...descriptionProps}>
                  <Text typeface="body-2-m">{description}</Text>
                </ToastDescription>
              )}
            </div>
            <div onClick={() => dismiss(id)}>
              {action ? action : <ToastClose variant={variant} />}
            </div>
          </Toast>
        );
      })}
      <ToastViewport {...viewportProps} />
    </ToastProvider>
  );
};
